// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Vd34","productName":"Table_productName__3aL1v"};